import React from 'react'
import { useIntl } from 'react-intl'

import { codeBoardMap } from '../index'

const BoardName = ({ code, name }: { code: string; name: string }) => {
  const intl = useIntl()

  if (codeBoardMap.has(code)) {
    const item = codeBoardMap.get(code)
    return <>{intl.formatMessage({ id: item?.name })}</>
  }

  return <>{name}</>
}

export default BoardName
